<template>
  <div class="w-full">
    <div class="w-full flex items-baseline justify-between">
      <label
        class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1"
        >{{ props.label }}
        <span v-if="props.required" title="obligatorisk">*</span></label
      >
      <div
        v-if="
          props.maxLength > 0 && props.maxLength - props.modelValue.length < 10
        "
        class="text-xs text-darkGray-3"
        :class="{
          'text-red-2': props.maxLength - props.modelValue.length < 0,
        }"
      >
        {{
          props.maxLength ? props.modelValue.length + "/" + props.maxLength : ""
        }}
      </div>
    </div>
    <input
      class="appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-3 px-4 leading-tight focus:bg-white focus:border-blue-1 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed"
      :class="{
        'border-red-2': props.error,
      }"
      type="text"
      :placeholder="props.placeholder"
      :value="props.modelValue"
      @input="
        $emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)
      "
      v-bind="$attrs"
      :required="props.required ? true : null"
      :disabled="props.disabled ? true : null"
    />
    <span v-if="props.errorMessage" class="text-red-2 mt-2"
      >{{ props.errorMessage }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
defineEmits(["update:modelValue"]);

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  keyId: String,

  modelValue: {
    type: String,
    default: "",
  },
  maxLength: {
    type: Number,
    required: false,
  },
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  error: {
    type: Boolean,
    required: false,
    default: false,
  },
  errorMessage: {
    type: String,
    required: false,
    default: "",
  },
});
</script>
